import { memo } from "react";
import { Competitor } from "../../Competitor/Competitor";
import { BoxScoreDetails } from "./BoxScoreDetails";
import { LiveStreamIcon } from "./LiveStreamIcon";
import { EventDetails } from "../../EventDetails/EventDetails";
import cx from "components/src/utils/cx";

const _BoxScoreMinimal = ({
  isVertical,
  isHorizontal,
  isPreGame,
  ariaLabelPreGame,
  ariaLabel,
  competitors,
  _id,
  variant,
  detailsProps,
  teams,
  breakpoint,
  hasLiveStream,
  secondaryEventDetailsSyncMapper,
  secondaryEventDetails,
  hideExtendedDetails,
  eventDetails,
  onClick,
  iconSize,
  scoreSize,
  _textSize,
  _competitorOne,
  _competitorTwo,
  _name,
  _showColorBars,
  animation,
  sport,
  competitionType,
  setRef,
  rest,
  _hideScorePadding,
}) => {
  return (
    <div
      className={cx(
        {
          "cui-px-md cui-flex cui-items-center cui-justify-center cui-w-auto":
            isVertical && isPreGame,
          "cui-flex cui-flex-col cui-px-md": isVertical && !isPreGame,
          "cui-px-md":
            isHorizontal &&
            breakpoint !== "xs-mobile" &&
            breakpoint !== "mobile",
          "cui-px-2xs": isHorizontal && breakpoint === "xs-mobile",
          "cui-gap-x-md":
            isHorizontal && breakpoint === "xs-mobile" && isPreGame,
          "cui-grid cui-grid-cols-[1fr,auto,1fr] cui-grid-rows-[1fr,auto] cui-justify-items-center cui-place-items-center":
            isHorizontal,
        },
        "cui__boxscore cui-py-xs cui-border-1 cui-border-solid cui-border-fg-minimal cui-bg-bg-layer-one cui-select-none cui-outline-none focus:cui-outline-none focus-visible:cui-ring-2 focus-visible:cui-ring-offset-1 focus-visible:cui-ring-fg-focus cui-relative"
      )}
      aria-label={isPreGame ? ariaLabelPreGame : ariaLabel}
      onClick={(e) => {
        onClick && onClick(competitors, e, _id);
      }}
      tabIndex={0}
      id={_id}
      {...rest}
      ref={setRef}
    >
      {variant === "vertical" ? (
        <>
          <div className="cui-w-full cui-flex">
            <div className="cui-flex cui-flex-col cui-w-full cui-justify-center cui-max-w-xs">
              <Competitor
                {..._competitorOne}
                iconSize="lg"
                tabbable={false}
                textSize="display-sm"
                sport={sport}
                competitionType={competitionType}
                hideScore={isPreGame}
                animation={animation}
              />
              <Competitor
                {..._competitorTwo}
                iconSize="lg"
                tabbable={false}
                textSize="display-sm"
                sport={sport}
                competitionType={competitionType}
                hideScore={isPreGame}
                animation={animation}
              />
            </div>
            <div className="cui-flex-grow" />
            <BoxScoreDetails {...detailsProps} />
          </div>
          {hasLiveStream && !isPreGame ? (
            <LiveStreamIcon className="cui-w-auto cui-self-end cui-mt-1" minimal={true} />
          ) : null}
        </>
      ) : (
        <>
          <ColorBar color={teams?.first?.colors?.at(0)} show={_showColorBars} />
          <div className="cui-justify-self-end cui-flex">
            <Competitor
              {..._competitorOne}
              compact
              inline
              force={_name}
              iconSize={iconSize}
              textSize={_textSize}
              tabbable={false}
              scoreSize={scoreSize}
              sport={sport}
              competitionType={competitionType}
              hideScore={isPreGame}
              hasScorePadding
              flipIcon={false}
              hideScorePadding={_hideScorePadding}
              animation={animation}
              textAlign="right"
              key={`cui-boxscore-competitor-1-${_id}-${breakpoint}`}
            />
          </div>
          <BoxScoreDetails {...detailsProps} />
          <div className="cui-justify-self-start cui-flex">
            <Competitor
              {..._competitorTwo}
              compact
              inverse
              inline
              force={_name}
              iconSize={iconSize}
              textSize={_textSize}
              tabbable={false}
              scoreSize={scoreSize}
              hideScore={isPreGame}
              sport={sport}
              competitionType={competitionType}
              hasScorePadding
              flipIcon={true}
              hideScorePadding={_hideScorePadding}
              animation={animation}
              key={`cui-boxscore-competitor-2-${_id}-${breakpoint}`}
            />
          </div>
          <ColorBar
            color={teams?.second?.colors?.at(0)}
            flip
            show={_showColorBars}
          />
          <div className="cui-col-span-3">
            {eventDetails && !hideExtendedDetails ? (
              <EventDetails
                {...secondaryEventDetails}
                syncMapper={secondaryEventDetailsSyncMapper}
                noPad
                noMinHeight
              />
            ) : null}
          </div>
        </>
      )}
    </div>
  );
};

export const BoxScoreMinimal = memo(_BoxScoreMinimal);

const ColorBar = ({
  flip,
  color,
  show,
}: {
  color?: string;
  flip?: boolean;
  show?: boolean;
}) => {
  if (!show) return null;
  return (
    <div
      className={cx(
        {
          "cui-left-0": !!!flip,
          "cui-right-0": !!flip,
        },
        "cui-absolute cui-top-0 cui-w-2 cui-h-full"
      )}
      style={{ background: color ? `${color}` : "var(--bg-layer-three)" }}
    />
  );
};
